// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  height: 100%;
}

.main-row {
  height: 100%;
}

ion-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 3px 0;
  border-radius: 15px;
  box-shadow: none;
  word-break: break-word;
  --color: var(--ion-color-subtitle);
  --preorder-type-chip-border-color: #F2F2F2;
  --preorder-type-chip-background: #F2F2F2;
  --preorder-type-chip-color: var(--ion-color-primary);
  word-break: break-word;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);
}
ion-card ion-card-content {
  padding: 10px;
}
ion-card ion-card-content:first-of-type {
  border: none;
}

.button-card-content {
  margin-top: auto;
}

.your-order-title {
  text-transform: uppercase;
  color: var(--ion-color-secondary);
  font-family: AppFontBold, sans-serif;
}

.header {
  font-size: 20px;
  font-family: AppFontExtraBold, sans-serif;
}

ion-chip {
  background: #E2DCD5;
  color: var(--ion-color-primary);
  height: 20px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin: 0px;
  font-size: 11px;
}

ion-col {
  font-family: AppFont, sans-serif;
}
ion-col b {
  font-family: AppFont300, sans-serif;
  font-size: 16px;
}

.text-align-end {
  text-align: end;
}

ion-button {
  font-family: AppFont, san-serif;
}

.separator {
  text-align: center;
  height: 5px;
  width: 100%;
  margin: 0 auto;
  fill: var(--ion-color-secondary);
}

.article_name {
  font-family: AppFontBold, sans-serif !important;
  color: var(--ion-color-primary) !important;
  font-size: 16px;
  font-weight: 100;
}

.block-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.block-button ion-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-order/my-order.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EAEA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;EACA,0CAAA;EACA,wCAAA;EACA,oDAAA;EACE,sBAAA;EAEE,4CAAA;AADN;AAEE;EACE,aAAA;AAAJ;AAEI;EACE,YAAA;AAAN;;AAKA;EACE,gBAAA;AAFF;;AAKA;EACE,yBAAA;EACA,iCAAA;EACA,oCAAA;AAFF;;AAIA;EACE,eAAA;EACA,yCAAA;AADF;;AAGA;EACE,mBAAA;EACA,+BAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAEA;EACE,gCAAA;AACF;AAAE;EACE,mCAAA;EACA,eAAA;AAEJ;;AACA;EACE,eAAA;AAEF;;AAAA;EACE,+BAAA;AAGF;;AADA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,gCAAA;AAIF;;AADA;EACI,+CAAA;EACE,0CAAA;EACA,eAAA;EACA,gBAAA;AAIN;;AAFA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAKF;AAJE;EACE,WAAA;AAMJ","sourcesContent":[":host {\n  display: block;\n  height: 100%;\n}\n\n.main-row {\n  height: 100%;\n}\n\nion-card {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  margin: 3px 0;\n\n  border-radius: 15px;\n  box-shadow: none;\n  word-break: break-word;\n  --color: var(--ion-color-subtitle);\n  --preorder-type-chip-border-color:  #F2F2F2;;\n  --preorder-type-chip-background:  #F2F2F2;;\n  --preorder-type-chip-color: var(--ion-color-primary);\n    word-break: break-word;\n\n      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.03);\n  ion-card-content {\n    padding: 10px;\n\n    &:first-of-type {\n      border: none;\n    }\n  }\n}\n\n.button-card-content {\n  margin-top: auto;\n}\n\n.your-order-title {\n  text-transform: uppercase;\n  color: var(--ion-color-secondary);\n  font-family: AppFontBold, sans-serif;\n}\n.header {\n  font-size: 20px;\n  font-family: AppFontExtraBold, sans-serif;\n}\nion-chip{\n  background:  #E2DCD5;\n  color: var(--ion-color-primary);\n  height: 20px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  margin: 0px;\n  font-size: 11px;\n}\nion-col {\n  font-family: AppFont, sans-serif;\n  b {\n    font-family: AppFont300, sans-serif;\n    font-size: 16px;\n  }\n}\n.text-align-end{\n  text-align: end;\n}\nion-button {\n  font-family: AppFont ,san-serif;\n}\n.separator {\n  text-align: center;\n  height: 5px;\n  width: 100%;\n  margin: 0 auto;\n  fill: var(--ion-color-secondary);\n\n}\n.article_name {\n    font-family: AppFontBold, sans-serif !important;\n      color: var(--ion-color-primary) !important;\n      font-size: 16px;\n      font-weight: 100;\n}\n.block-button {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  ion-button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
